import { Component, ElementRef, HostListener, OnInit, ViewChild } from "@angular/core";
import { DataService } from "../../shared/services/data.service";
import { ParcelService } from "../../shared/services/parcel.service";
import { MessageService, SortMeta } from "primeng/api";
import { Location } from '@angular/common';
import { Table } from "primeng/table";
import { User } from "./user-interface";
import { SpinnerComponent } from "../../shared/components/spinner/spinner.component";
import { PRIMENG_MODULES } from "../../shared/primeng-imports";
import * as XLSX from 'xlsx';
@Component({
    selector: 'app-user-management',
    templateUrl: './user-management.component.html',
    styleUrl: './user-management.component.scss',
    standalone: true,
    imports: [...PRIMENG_MODULES, SpinnerComponent]
})


export class UsersManagementComponent implements OnInit {


    users: User[] = [];
    changedUsers: User[] = [];
    activeCount = 0;
    inactiveCount = 0;
    showSummary = false;
    filterByGroup: string = '';
    isLoading: boolean = false;
    statuses = [
        { label: 'Active', value: true },
        { label: 'InActive', value: false }
    ];
    @ViewChild('dt') dt!: Table;
    @ViewChild('filterInput') filterInput!: ElementRef;
    totalCount: number = 0;

    rowCount: number = 10;
    multiSortMeta: SortMeta[] = [
        { field: 'lastLoginAt', order: -1 }, // order: 1 for ascending, -1 for descending
        { field: 'userName', order: 1 }
    ];
    constructor(
        private dataService: DataService,
        private parcelServices: ParcelService,
        private messageService: MessageService,
        private location: Location

    ) { }

    ngOnInit() {
        this.dataService.updateShowMaintabs(false);
        this.reLoad();
        this.updateRows(window.innerWidth);
    }
    ngOnDestroy() {
        this.dataService.updateShowMaintabs(true);
    }
    goBack() {
        this.location.back();
    }
    reLoad(clearFilter = false) {
        if (clearFilter)
            this.dt.clear();
        if (this.filterInput)
            this.filterInput.nativeElement.value = '';
        this.multiSortMeta = [
            { field: 'lastLoginAt', order: -1 }, // order: 1 for ascending, -1 for descending
            { field: 'userName', order: 1 }
        ];

        this.isLoading = true;

        this.dataService.currentGroupData.subscribe({
            next: (result) => {
                var showDenmarkUsers = (result.filter(grp => grp.includes('DIA-CustomsAdminUser-'))).length > 0 ? true : false;
                var showSwedenUsers = (result.filter(grp => grp.includes('DIA-NormalUser-'))).length > 0 ? true : false;
                // if (showDenmarkUsers && !showSwedenUsers) {
                //     this.filterByGroup = "Denmark";
                // }
                // else if (!showDenmarkUsers && showSwedenUsers) {
                //     this.filterByGroup = "Sweden";
                // } else {
                this.filterByGroup = "all";
                // }
            }
        })
        this.parcelServices.listUserLoginActivity().subscribe({
            next: (result) => {
                this.isLoading = false;

                const cutoff = new Date();
                const currentDay = cutoff.getDate();
                cutoff.setDate(1);
                cutoff.setMonth(cutoff.getMonth() - 8);
                const lastDay = new Date(cutoff.getFullYear(), cutoff.getMonth() + 1, 0).getDate();
                cutoff.setDate(Math.min(currentDay, lastDay));

                const mappedUsers = result.data.users.filter((res: any) => this.filterByGroup === res.group || this.filterByGroup === 'all').map((res: any) => ({
                    'userName': res.userId,
                    'lastLoginAt': (new Date(new Date(res.lastLoginAt * 1000).toISOString())).toLocaleString(),
                    'isActive': res.isActive,
                    'group': res.group,
                    'originalStatus': res.isActive,
                    'isStale': this.isOlderThanEightMonths(res.lastLoginAt, cutoff),

                }))
                this.users = mappedUsers;
                this.totalCount = this.users.length;
            },
            error: (err) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Failed to export file',
                    detail: err?.message || 'Something went wrong , Please try again'
                });
                this.isLoading = false;
            }
        }
        )
    }
    private isOlderThanEightMonths(value: number | string | null | undefined, cutoff: Date): boolean {
        if (value === null || value === undefined || value === '') {
            return false;
        }

        const timestamp = typeof value === 'number' ? value * 1000 : Date.parse(value);
        return Number.isFinite(timestamp) && timestamp < cutoff.getTime();
    }

    getSeverity(status: string): any {
        switch (status) {
            case 'InActive':
                return 'danger';

            case 'Active':
                return 'success';
        }
    }
    hasFilters(table: any) {
        if (!table?.filters) return false;

        return Object.values(table.filters).some((filter: any) => {
            return filter?.value !== null && filter?.value !== undefined && filter?.value !== '';
        });
    }

    getUsersToExport(): User[] {
        const filteredUsers = this.dt?.filteredValue as User[] | null | undefined;
        return Array.isArray(filteredUsers) ? filteredUsers : this.users.filter(user => !user.isActive);
    }

    exportUsers() {
        const rows = this.getUsersToExport().map(user => [
            user.userName,
            user.lastLoginAt,
            user.isActive ? 'Active' : 'Inactive',
            user.group
        ]);
        const worksheet = XLSX.utils.aoa_to_sheet([
            ['Email', 'Last Login', 'Status', 'Group'],
            ...rows
        ]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Users');
        XLSX.writeFile(workbook, `users_${new Date().toISOString().slice(0, 10)}.xlsx`);
    }


    onSubmit() {
        this.changedUsers = this.users.filter(
            u => u.isActive !== u.originalStatus
        );

        this.activeCount = this.changedUsers.filter(u => u.isActive).length;
        this.inactiveCount = this.changedUsers.filter(u => !u.isActive).length;

        if (this.changedUsers.length) {
            this.showSummary = true;
        }
    }
    hasChanged() {
        return this.users.some(u => u.isActive !== u.originalStatus);
    }
    confirmSubmit() {
        this.isLoading = true;

        const payLoad = this.changedUsers.map(u => ({ userId: u.userName, isActive: u.isActive }))
        this.parcelServices.udpateStatus(payLoad).subscribe({
            next: (result) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Successfuly updated status'
                });
                this.isLoading = false;
                this.closeDialog();

            },
            error: (err) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Failed to update status',
                    detail: err?.message || 'Something went wrong , Please try again'
                });
                this.isLoading = false;
                this.closeDialog();
            }
        }
        )
    }
    closeDialog() {
        this.showSummary = false;
        this.reLoad();
    }

    updateRows(width: number) {
        if (width >= 2560) {
            this.rowCount = 20;
        } else {
            this.rowCount = 10;
        }
    }


}